import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import AdminDashboard from './pages/AdminDashboard';
import LearnerDashboard from './pages/LearnerDashboard';
import TestTaking from './pages/TestTaking';
import TestResults from './pages/TestResults';
import Register from './pages/Register';
import './styles/App.css';

// Role-based redirect component
const RoleBasedRedirect = () => {
  const { currentUser, userRole, loading } = useAuth();
  
  if (loading) return <div>Loading...</div>;
  if (!currentUser) return <Navigate to="/login" />;
  
  if (userRole === 'admin') return <Navigate to="/admin" />;
  if (userRole === 'learner') return <Navigate to="/learner" />;
  
  return <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {/* Admin routes */}
            <Route path="/admin" element={<AdminDashboard />} />
            
            {/* Learner routes */}
            <Route path="/learner" element={<LearnerDashboard />} />
            <Route path="/register" element={<Register />} />
            <Route path="/test/:testId" element={<TestTaking />} />
            <Route path="/results/:attemptId" element={<TestResults />} />
            <Route path="/lesson-test/:testId" element={<TestTaking isLessonTest={true} />} />
            {/* Default redirect based on role */}
            <Route path="/" element={<RoleBasedRedirect />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;